import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  public menu_responsive = false;

  constructor() { }

  ngOnInit(): void {
  }

  menuEvent($event:boolean) {
    this.menu_responsive = $event;
  }

}
